<script>
import ProInput from '$common/ProInput'
export default {
  name: 'ScholarshipOffer',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    },
  },
  data () {
    return {
      scholarshipRebuttal: '',
      cardReady: false,
      state: 'user',
    }
  },
  computed: {
    guardian () {
      return this.options.guardian
    },
    application () {
      return this.options.application
    },
    paymentButtonCopy () {
      return {
        user: 'Submit',
        system: 'Loading...',
      }[this.state]
    },
    isApprovedNotPaid () {
      return this.guardian.application_status === 'APPROVED_NOT_PAID'
    },
  },
  methods: {
    setUpStripeElement () {
      // eslint-disable-next-line
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
      const elements = this.stripe.elements()

      this.card = elements.create('card')

      this.card.on('change', (event) => {
        this.cardReady = event.complete
      })

      this.card.mount('#card-element')
    },
    async onPayment () {
      if (!this.cardReady) return this.$toast('Please fill out card info')
      if (this.state !== 'user') return this.$toast('Already submitted')

      this.state = 'system'

      let card
      try {
        card = (await this.stripe.createToken(this.card)).token
      } catch (e) {
        this.$toast({
          copy: 'Problem with card',
          class: 'alert',
        })
        this.isLoading = false
        return console.log(e)
      }
      

      try {
        await this.$HTTP({
          method: 'post',
          uri: `users/${this.guardian.id}/scholarship-payment`,
          body: {
            card,
          },
        })
        this.options.onSuccess()
        this.$toast('Successful payment!')
        this.$modals.hide('scholarship-offer')
      } catch (e) {
        console.error(e)
        this.$toast({
          copy: e.body.message,
          class: 'alert',
        })
        this.state = 'user'
      }
    },
    async onRebuttal () {
      if (!this.scholarshipRebuttal) return this.$toast('Please input reasoning')
      this.$toast('Sending...')
      try {
        await this.$firestore.doc(`users/${this.guardian.id}`).update({
          scholarship_rebuttal: this.scholarshipRebuttal,
          application_status: 'SCHOLARSHIP_REBUTTED',
        })
        this.$toast('Sent!')
        this.$modals.hide('scholarship-offer')
        this.options.onSuccess()
      } catch (e) {
        console.error(e)
        this.$toast('Could not send.')
      }
    },
  },
  mounted () {
    this.setUpStripeElement()
  },
}
</script>

<template lang="pug">
  #scholarship-offer-main.modal-main
    .scholarship-offer-container.modal-container

      .title.exit(
        @click='$modals.hide("scholarship-offer")'
      ) Scholarship
      .content 
        .scholarship-area 
          .copy You have been offered a scholarship. Your total amount to pay is
          .amount.font-1-bold {{$toCurrency(isApprovedNotPaid ? Number(application.can_pay) : guardian.counter_offer)}}
          .copy Complete your registration by paying below.
          .card-holder
            #card-element
          .buttons-holder
          .pro-button.major(
            @click='onPayment'
          ) {{paymentButtonCopy}}

        .more-info-area(
          v-if='!isApprovedNotPaid'
        )
          .copy If you feel you cannot pay the amount above, let us know why and we will consider a different scholarship amount.
          pro-input(
            v-model='scholarshipRebuttal'
            :options='{type: "textarea", title: "Let us know", height: "80px"}'
          )
          .pro-button(
            @click='onRebuttal'
          ) Send


</template>

<style lang="sass" scoped>
  #scholarship-offer-main
    .scholarship-offer-container
      .content
        padding: 0
        .scholarship-area
          padding: 2rem 1rem
          display: grid
          .copy
            font-size: 18px
            text-align: center
          .amount
            font-size: 48px
            text-align: center
            margin: 1rem 0
          .card-holder
            margin: 2rem 0 1rem
            box-shadow: 0 0 5px 0 grey
            padding: 1rem
            border-radius: .5rem
          .pro-button
            padding: .5rem 2rem
            font-size: 20px
            margin: 1rem 0 0
            justify-self: right
        .more-info-area
          background-color: black
          padding: 1rem
          color: white
          display: grid
          .copy
            font-size: 14px
            margin-bottom: 1rem
          .pro-button
            background-color: white
            color: black
            justify-self: right
</style>